import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { SendPageView } from '../../utils/gtag';

const ga: (props: RouteComponentProps) => JSX.Element = (props: RouteComponentProps) => {
    if (props.history.action === 'PUSH') {
        SendPageView(window.location.href, props.location.pathname);
    }
    return <></>;
};

export const GoogleAnalytics = withRouter(ga);
